import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { LogoContainer, LogoImg } from './style';
import { getUrlWithToken } from '../../../utils/common';

const Logo = ({
  size = Logo.SIZE.MEDIUM,
  defaultLogo = false,
  onClick,
  src,
  logo,
  alt,
}) => {
  const [logoSrc, setLogoSrc] = useState();

  useEffect(() => {
    if (defaultLogo) setLogoSrc(logo?.src);
    else setLogoSrc(src);
  }, [defaultLogo, logo, src]);

  return (
    <LogoContainer size={size} onClick={onClick}>
      <LogoImg
        src={getUrlWithToken(logoSrc)}
        alt={!defaultLogo ? alt : logo?.alt}
      />
    </LogoContainer>
  );
};

Logo.SIZE = {
  SMALL: 'small',
  MEDIUM: 'medium',
  LARGE: 'large',
  XL: 'xl',
};

Logo.propTypes = {
  size: PropTypes.oneOf(Object.values(Logo.SIZE)),
  onClick: PropTypes.func,
  logo: PropTypes.object,
  src: PropTypes.string,
  alt: PropTypes.string,
  defaultLogo: PropTypes.bool,
};

export default connect((state) => {
  const {
    appConfig: { logo },
  } = state.app;
  return { logo };
})(Logo);
